const alertBanner = document.querySelector('.alert');
const browserHeader = document.querySelector('.alert.browser-header');
const dismissedAlertsStorageKey = 'alert-dismissed';
const dismissedBannersStorageKey = 'banner-dismissed';

showBanner(alertBanner, dismissedAlertsStorageKey);
showBanner(browserHeader, dismissedBannersStorageKey);





function showBanner(banner, sessionKey) {
	if (banner != null) {

	  //const dismissedAlertsStorageKey = 'alert-dismissed';
	  const dismissedAlerts = sessionStorage.getItem(sessionKey) === null;

	  if (dismissedAlerts){
		banner.classList.remove('d-none');
	  }

	  banner.addEventListener('closed.bs.alert', function () {
		sessionStorage.setItem(sessionKey, 'acknowledged');
	  })

	}
}